import { PredictionService } from '@/app/core/services/prediction/prediction.service';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import {
  GetExitPointPredictionAction,
  SetMarketsFilter,
  SetGatesFilter,
  SetCreg185,
} from './exit-point-prediction.action';
import { catchError, tap, throwError } from 'rxjs';
import { EnovaAlertsComponent } from '@/app/core/utils/enova-alerts/enova-alerts.component';

export interface ExitPointPredictionStateModel {
  exitPointData: any;
  marketsFilter: any[];
  gatesFilter: any[];
  creg185: boolean;
}

@State<ExitPointPredictionStateModel>({
  name: 'exitPointPrediction',
  defaults: {
    exitPointData: [],
    marketsFilter: [],
    gatesFilter: [],
    creg185: false,
  },
})
@Injectable()
export class ExitPointPredictionState {
  @Selector()
  static getExitPointData(state: ExitPointPredictionStateModel): any {
    return state?.exitPointData ? state.exitPointData : [];
  }

  @Selector()
  static getMarketsFilter(state: ExitPointPredictionStateModel): any[] {
    return state?.marketsFilter || [];
  }

  @Selector()
  static getGatesFilter(state: ExitPointPredictionStateModel): any[] {
    return state?.gatesFilter || [];
  }

  @Selector()
  static getCreg185(state: ExitPointPredictionStateModel): boolean {
    return state?.creg185 || false;
  }

  constructor(
    private predictionService: PredictionService,
    public dialog: MatDialog
  ) {}

  @Action(SetMarketsFilter)
  setMarketsFilter(
    ctx: StateContext<ExitPointPredictionStateModel>,
    action: SetMarketsFilter
  ) {
    ctx.patchState({
      marketsFilter: action.payload,
    });
  }

  @Action(SetGatesFilter)
  setGatesFilter(
    ctx: StateContext<ExitPointPredictionStateModel>,
    action: SetGatesFilter
  ) {
    ctx.patchState({
      gatesFilter: action.payload,
    });
  }

  @Action(SetCreg185)
  setCreg185(
    ctx: StateContext<ExitPointPredictionStateModel>,
    action: SetCreg185
  ) {
    ctx.patchState({
      creg185: action.payload,
    });
  }

  @Action(GetExitPointPredictionAction)
  async GetCustomerPredictionAction(
    ctx: StateContext<ExitPointPredictionStateModel>,
    action: GetExitPointPredictionAction
  ) {
    const { startDate, endDate, filters } = action.payload;

    ctx.patchState({
      exitPointData: [],
    });
    return this.predictionService
      .getCityGatesForPrediction(startDate, endDate, filters)
      .pipe(
        tap((response: any) => {
          ctx.patchState({
            exitPointData: response,
          });
        }),
        catchError((error: any) => {
          ctx.patchState({
            exitPointData: [],
          });
          this.dialog.open(EnovaAlertsComponent, {
            width: 'auto',
            data: {
              type: 'error',
              text:
                error?.error?.details ||
                error?.details ||
                error?.message ||
                'Ha ocurrido un error al obtener los datos',
              hiddeCancelBtn: true,
            },
          });
          return throwError(() => error);
        })
      );
  }
}
